@if (registrationHistoryMonth?.count! > 0) {
  <div
    id="divRegistrationHistoryMonth"
    class="chart-container"
    >
    <canvas id="registrationHistoryMonth"></canvas>
  </div>
}
